/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
/* eslint-disable @typescript-eslint/no-unused-vars */
import styles from '../styles/Home.module.css';
import 'react-phone-number-input/style.css'
import { useEffect, useState } from 'react';
import { CallbackType, FRAuth, FRLoginFailure, FRLoginSuccess, FRStep, StepType } from '@forgerock/javascript-sdk';
import Loading from '../components/02-molecules/Loading';
import { trees } from '../config/';
import { IStageProgressBadge, StageProgressBadge } from '../components/layout/StageProgressBadge';
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import ValidateCode from '../components/forms/common/ValidateCode';
import FROutputCallbackBasedView from '../components/forms/common/FROutputCallBackBasedView';
import AcceptTermsAndConditions from '../components/forms/common/AcceptTermsAndConditions';
import SuspendMessage from '../components/forms/common/SuspendMessage.tsx';
import { getInitialStageItems, getStageHeader } from '../util/generalUtility';
import { MessageType } from '../components/modals/SuccessErrorModal';
import { appInsights } from '../appInsights/appInsights';

const treeData = trees.userOnbaordingForm;

const UserRegistration = () => {
  const [step, setStep] = useState<FRStep | FRLoginFailure | FRLoginSuccess | null>(null);
  const [tree, setTree ] = useState(treeData);
  const [stageItems, setStageItems] = useState<IStageProgressBadge[]>([]);
  const[stageHeaderList,setStageHeaderList] = useState<{name:string,stageName:string}[]>([])
  const [messageType, setMessageType] = useState(MessageType.info);
  const [message, setMessage] = useState('');  
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  useEffect(() => {
    appInsights.trackPageView({name: 'User Registration'});     
  },[]);

  useEffect(() => {
    (async function getStep() {
      const resumeCode = new URLSearchParams(window.location.search).get('resumeCode') || '';
      try {
        const initialStep = await FRAuth.start({ tree, query: { resumeCode } });
        if(initialStep && initialStep.type===StepType.Step){
          setStageHeaderList(getStageHeader(initialStep));
          setStageItems(getInitialStageItems(initialStep,getStageHeader(initialStep)));
        }
        setStep(initialStep);
      } catch (err) {
        console.error(`Error: request for initial step; ${err}`);
      }
    })();
  }, []);


  const updateStageItems =(stage: string | undefined) => {
    const stageItemForUpdate = cloneDeep(stageItems);
    if(step && step.type===StepType.Step){
      stageHeaderList?.forEach((value:{name:string,stageName:string},index:number)=>{
        if(stageItemForUpdate[index].className==='active'){
          stageItemForUpdate[index].className='completed';
        }
          if(stage===value.stageName){
            stageItemForUpdate[index].className='active';
          } 
      })
      // This logic is for back button clicks 
      stageItemForUpdate?.reverse().every((v:any,index:number)=>{
        if (stageItemForUpdate[index].className==='disabled')
        {
          return true;
        } else if(stageItemForUpdate[index].className==='active')
        {
          return false;
        }
        else if(stageItemForUpdate[index].className==='completed')
        {
          stageItemForUpdate[index].className='disabled'
          return true;
        }
    })

    }
    let stageItemForUpdatefinal=stageItemForUpdate.reverse();
    setStageItems(stageItemForUpdatefinal);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  useEffect(() => {
    if (!isNil(step) && step && step.type === StepType.Step) {
      step.callbacks.forEach((callback, i) => {
        const type = callback.getType();
        if (type === CallbackType.RedirectCallback) {
          if (callback.getOutputValue("trackingCookie")) {
            // save current step information for later resumption of tree.
            sessionStorage.setItem("authIndexValue", tree);
            sessionStorage.setItem("step", JSON.stringify(step));
            sessionStorage.setItem("realm", "PnW");
            localStorage.setItem(FRAuth.previousStepKey, JSON.stringify(step));
          }
          const redirectUrl = callback.getOutputValue("redirectUrl") as string;
          if (callback.getOutputValue("redirectMethod") === "POST") {
            const redirectData = callback.getOutputValue(
              "redirectData"
            ) as string;
            const form = document.createElement("form");
            form.method = "post";
            form.action = redirectUrl;

            Object.entries(redirectData as string).forEach(([key, value]) => {
              const hiddenField = document.createElement("input");
              hiddenField.type = "hidden";
              hiddenField.name = key;
              hiddenField.value = value;

              form.appendChild(hiddenField);
            });

            document.body.appendChild(form);
            form.submit();
          } else {
            window.location.href = redirectUrl;
          }
          return;
        }
      });
      updateStageItems(step.getStage());
    }
  }, [step]);


  const getUserRegistrationView=()=>{
    let uiElement:JSX.Element=<Loading size={100}/>; 
    if(step && step.type===StepType.Step){
      switch(step.getStage()){
        case 'ValidateCode' :
         uiElement =<> <StageProgressBadge key={1} items={stageItems} />
         <ValidateCode  step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen}/>
         </> 
          break;
        case 'GetEmail': 
          uiElement=<> <StageProgressBadge key={1} items={stageItems} />
          <FROutputCallbackBasedView  step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen}/></>
          break;
        case 'SelectCompany':
        case 'RegistrationForm':
        case 'Account':  
        sessionStorage.removeItem('mfacode');
        sessionStorage.removeItem('mfastate');
        sessionStorage.removeItem('step');
          uiElement=<> <StageProgressBadge key={1} items={stageItems} />
          <FROutputCallbackBasedView  step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen}/></>
          break;
        case 'TermsAndConditions':
          uiElement = <> <StageProgressBadge key={1} items={stageItems} />
          <AcceptTermsAndConditions step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen}/> 
          </>
          break;
        case 'SuspendMessage':
        sessionStorage.removeItem('mfacode');
        sessionStorage.removeItem('mfastate');
        sessionStorage.removeItem('step'); 
          uiElement = <SuspendMessage step={step as FRStep}/>;
          break;
      }
    }else if(step && step.type === StepType.LoginFailure){
      setUpIntialStep(step.payload.message || '');
     
    }
    return uiElement;
  }

 const setUpIntialStep=async(message:string)=>{
    const initialStep = await FRAuth.start({ tree });
    if(initialStep && initialStep.type===StepType.Step){
      setStageHeaderList(getStageHeader(initialStep));
      setStageItems(getInitialStageItems(initialStep,getStageHeader(initialStep)));
    }
    setStep(initialStep);
    setIsAlertOpen(true)
    setMessageType(MessageType.error);
    setMessage(message)

  }

 return (
    <div className={styles.container}>
      <main className={styles.main}>  
       {getUserRegistrationView()}
      </main>
    </div>
  );
};

export default UserRegistration;
